/**
 * @fileoverview
 * This file contains functions that manage and handle different permissions
 * within the application, facilitate role-based access control.
 */

import { UserDto } from '../advanced-settings/overview'

export function getCanCreateInstallations(user: UserDto | undefined): boolean {
  if (!user) return false
  return user.level === 'EXT_SERVICE_PLUS' || user.level === 'INSTALLER'
}

export function getCanConfigureBatteryLowerDischargeThreshold(user: UserDto | undefined): boolean {
  if (!user) return false
  return user.level === 'EXT_SERVICE_PLUS' || user.level === 'INSTALLER'
}

export function getCanViewDiagnosticsPage(user: UserDto | undefined): boolean {
  if (!user) return false
  return user.level === 'EXT_SERVICE_PLUS' || user.level === 'INSTALLER'
}
